import {
	isStoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getStoreMessageId } from './getStoreMessageId';

/**
 * An A2UI action starts a new turn without inserting a message, so the thinking indicator
 * anchors to the acted-on host message, whose completed-turn flags would keep it hidden.
 * `markStreamingMessagesAsComplete` re-stamps them when the action's stream ends.
 */
export const clearCompletedTurnFlags = (
	chat: StoreChatItem[],
	messageId: string,
): StoreChatItem[] =>
	chat.map((chatItem) => {
		if (isStoreAssistant(chatItem) && getStoreMessageId(chatItem) === messageId) {
			return {
				...chatItem,
				hasReceivedAnswerPart: undefined,
				content: { ...chatItem.content, streamingComplete: undefined },
			};
		}
		return chatItem;
	});
